import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Dialog from '../../../utils/utilities/Dialog';
import PaymentForm from '../../Payments/Components/PaymentForm';

import { Button, Card, CardContent, CardHeader, CardActionArea, Divider, lighten, darken } from '@mui/material';

import { BasicFlex } from '../../../utils/Common';

import AddRounded from '@mui/icons-material/AddRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import { useMutation, useQuery } from '@tanstack/react-query';

import { processPayment } from '../../Payments/apiService';

import useSnackbarStore from '../../../store/snackbar';

import Field from '../../../utils/FormikFields/Field';

import useIsMobile from '../../../hooks/useIsMobile';

import { formatCurrency } from '../../../utils/util';

import { getAvailablePaymentsByCustomer } from '../../Payments/apiService';

import HelpTooltip from '../../../utils/utilities/HelpTooltip';

import { isEmpty } from 'lodash';

import { useDialogForm } from '../../../contexts/DialogForm';

const SummaryCard = styled(Card)`
  width: 100%;
`

const BalanceTotal = styled.div`
  min-width: fit-content;
  flex-grow: 1;
`

const BalanceAmount = styled.div`
  font-weight: ${props => props.$total ? '600' : '500'};
  font-size: ${props => props.$total ? '1.6rem' : '1.4rem'};
  color: ${props => props.$balance ? props.theme.colors.error : "inherit"};
`

const SwitchContainer = styled.div`
  margin-top: 1.5rem;
  padding-left: .5rem;
`

const ErrorPanel = styled.ul`
  /* list-style-type: none; */
  color: ${props => props.theme.colors.error};
  background-color: ${props => lighten(props.theme.colors.error, .9)};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.error};
  /* font-size: 1.2rem; */
  margin: 1.5rem;
  margin-top: 0;
  padding: 2rem;
  width: calc(100% - 3rem);
`

const BalanceLine = ({title, description, amount, total = false, balance = false}) => {
  let check_red = balance && +amount > 0 ? true : false
  const { isNotDesktop } = useIsMobile();
  return (
    <BasicFlex dir="row" justify="space-between" align="center">
      <BalanceTotal>{title}</BalanceTotal>
      <BasicFlex width="20rem">
        <div>{!isNotDesktop ? description : ""}</div>
        <BalanceAmount $total={total} $balance={check_red}>{formatCurrency(amount || 0)}</BalanceAmount>
      </BasicFlex>
    </BasicFlex>
  )
}

const AddPayment = () => {
  const { values, errors, setFieldValue, setTouched, validateForm, setErrors } = useFormikContext() || {};
  const { formValues, setFormValues } = useFormData() || {};

  const { handleClose } = useDialogForm() || {};

  let customer = formValues?.customer || values || {};

  let past_balance = customer?.final_balance || 0;

  let available_credit = past_balance < 0 ? Math.abs(past_balance) : 0;

  const showSnackBar = useSnackbarStore(state => state.showSnackbar);

  const { mutate, isPending } = useMutation({
    mutationFn: processPayment,
    onSuccess: (data) => {
      let newPayment = {
        payment_id: data.payment_id,
        client_name: data.client_name,
        amount: data.amount,
        display_amount: data.display_amount,
        method: data.method,
        status: data.status,
        available_amount: data.available_amount,
        info: data.info,
        notes: data.notes
      }
      setFormValues(ofv => {
        return {
          ...ofv,
          new_payments: ofv?.new_payments?.length ? [...ofv?.new_payments, newPayment] : [newPayment]
        }
      })
     showSnackBar('Payment added successfully!', 'success');
    },
    onError: (e) => {
      let message = e?.response?.data?.message
      showSnackBar(`Failed to process payment: ${message}`, 'error');
    }
  });

  useEffect(() => {
    let new_payments_total = formValues?.new_payments?.reduce((acc, el) => acc + +el?.amount, 0) || 0;
    let total_payments = values.apply_credit ? +available_credit + +new_payments_total : +new_payments_total;
    setFieldValue('total_amount', +total_payments);
  }, [values.apply_credit, available_credit, formValues.new_payments])

  const process = async () => {
    let packet = {
      customer_id: customer.customer_id,
      client_name: customer.full_name || customer.client_name,
      amount: values.amount,
      method: values.method,
      use_cc_fee: values.use_cc_fee,
      cc_rate: values.cc_rate,
      date: values.payment_date || new Date(),
      entry: values.entry,
      info: values.info,
      checkout_id: values.checkout_id,
      notes: values.notes
    }

    mutate({packet});
  }

  // const saveFunc = async () => {
  //   if (["sola", "banquest"].includes(values.entry)) return true;

  //   if (!customer?.customer_id) {
  //     setTouched({customer_id: true});
  //     console.log("customer_id");
  //     return false;
  //   }
  //   if (!values?.amount) {
  //     setTouched({amount: true});
  //     console.log("amount");
  //     return false;
  //   }
  //   if (!values?.method) {
  //     // setTouched({method: true});
  //     console.log("method");
  //     return false;
  //   }
  //   if (!values?.payment_date) {
  //     setTouched({payment_date: true});
  //     console.log("payment_date");
  //     return false;
  //   }
  //   await process();
  //   // handleClose();
  // }

  return (
    <Dialog title="Add Payment" size="lg" saveText="Add Payment" toggle={ <Button startIcon={<AddRounded />} fullWidth color="secondary" variant="outlined">Add Payment</Button>} useForm={true}>
      <PaymentForm dialog={true} dateField={true} />
      {values?.entry === "manual" ? <SaveForm process={process} /> : null}
    </Dialog>
  );
};

const SaveForm = ({ process }) => {
  const { formValues, setFormValues } = useFormData() || {};
  const { values, setFieldValue } = useFormikContext() || {};

  const { handleClose } = useDialogForm() || {};

  let customer = formValues?.customer || values || {};

  const [ errors, setErrors ] = useState({});

  const cancel = () => {
    handleClose();
  }

  const saveFunc = async () => {
    if (["sola", "banquest"].includes(values.entry)) return true;

    setErrors({});

    if (!customer?.customer_id) {
      setErrors(x => ({...x, customer_id: "Customer is required"}));
      return false;
    }
    if (!values?.amount) {
      setErrors(x => ({...x, amount: "Amount is required"}));
      return false;
    }
    if (!values?.method) {
      // setTouched({method: true});
      setErrors(x => ({...x, method: "Please select a payment method"}));
      return false;
    }
    // if (!values?.payment_date) {
    //   setErrors(x => ({...x, payment_date: "Payment date is required"}));
    //   return false;
    // }
    await process();
    handleClose();
  }

  return (
    <BasicFlex dir="column" width="100%">
      {/* <Divider /> */}
      {!isEmpty(errors) ? <ErrorPanel>
        {Object.values(errors).map((el, i) => <li key={i}>{el}</li>)}
      </ErrorPanel> : null}
      <BasicFlex justify="flex-end" my=".5rem" gap="1rem" px="1.5rem">
        <Button variant="outlined" startIcon={<HighlightOffRoundedIcon />} onClick={() => cancel()} color="secondary">Cancel</Button>
        <Button startIcon={<AddRounded />} variant="contained" onClick={() => saveFunc()}>Add Payment</Button>
      </BasicFlex>
    </BasicFlex>
  )
}

const PaymentCard = ({ invoice_balance }) => {
  const { values, errors, setFieldValue } = useFormikContext() || {};
  const { formValues, setFormValues } = useFormData() || {};

  let customer = formValues?.customer || values || {};

  const { data: unused_funds } = useQuery({
    queryKey: ['payments', "available", customer?.customer_id],
    queryFn: () => getAvailablePaymentsByCustomer(customer?.customer_id),
    enabled: !!customer?.customer_id
  })

  let past_balance = customer?.final_balance || 0;

  // let available_credit = past_balance < 0 ? Math.abs(past_balance) : 0;
  let available_credit = unused_funds?.reduce((acc, el) => acc + +el?.available_amount, 0) || 0;

  let new_payments_total = formValues?.new_payments?.reduce((acc, el) => acc + +el?.amount, 0) || 0;

  let total_payments = values.apply_credit ? +available_credit + +new_payments_total : +new_payments_total;

  useEffect(() => {
    if (available_credit <= 0) return

    if (values?.balance > 0) {
      setFieldValue('apply_credit', true);
    }
  }, [values?.balance, available_credit]);

  return (
    <SummaryCard variant='outlined'>
      <CardHeader title="Payments" />
      <CardContent >
        <BasicFlex dir="column" gap="1.5rem">
          <BalanceLine title={<BasicFlex width="fit-content" gap=".3rem"><span>Available Credit</span><HelpTooltip title="Credit from earlier payments that hasn't been applied yet, available for this invoice" /></BasicFlex>} description="" amount={available_credit} />
          <BalanceLine title="New Payments" description="2 Products" amount={new_payments_total} />
          <BalanceLine title="Total Amount" description="2 Products" amount={total_payments} total={true} />
        </BasicFlex>
        <Divider sx={{margin: "1.5rem 0"}} />
        <SwitchContainer>
          <Field formFieldType="switch" type="checkbox" name="apply_credit" label="Use Available Credit" color="secondary" disabled={!available_credit || invoice_balance <= 0} />
        </SwitchContainer>
      </CardContent>
      <Divider />
      <CardActionArea sx={{padding: "1rem"}}>
        <AddPayment />
      </CardActionArea>
    </SummaryCard>
  )
}

export default PaymentCard;